import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import PageTitleWrapper from 'src/components/PageTitleWrapper';

import FlowCustomContent from './FlowCustomContent';
import PageHeader from './PageHeader';

function FlowCustom() {
  return (
    <>
      <Helmet>
        <title>Flow Custom - Management</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>

      <Grid
        sx={{
          px: 4,
        }}
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item xs={12}>
          <FlowCustomContent />
        </Grid>
      </Grid>
    </>
  );
}

export default FlowCustom;
